import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useIdCatalogSearch } from '../components/SideMenuSearchLane/context';
import { orderModules } from '../components/StandardizationProject';
import useCreateProjectModule from '../components/StandardizationProject/hooks/useCreateProjectModule';
import useGetModuleScoringTableStructure from '../components/StandardizationProject/hooks/useGetModuleScoringTableStructure';
import { useStandardization } from '../screens/StandardizationScreen/context';

export default function useCreateEditModuleModal() {
  const { setIsSideMenuCollapsed } = useIdCatalogSearch();
  const { getScoringTableStructure } = useGetModuleScoringTableStructure();
  const { createModule, isLoading: isCreatingModule } = useCreateProjectModule();
  const {
    standardizationProject,
    isStandardizationProjectLoading,
    setSelectedStandardizationProject,
    toggleLeftSideMenu,
      modules,
      setModules,
  } = useStandardization();

  const [referenceModule, setReferenceModule] = useState(null);
  const [editableProject, setEditableProject] = useState(null);
  const [moduleModal, setModuleModal] = useState({
    isOpen: false,
    module: null,
    defaultFields: {},
  });

  const addNewModuleLocally = (newModule) => {
    console.log('addNewModuleLocally', newModule);
    const m = [...(modules || [])];
    m.push(newModule);
    const _modules = orderModules(m);
    const changes = { _modules };

    if (newModule.totalSiScore && newModule.totalSiScoreVendor) {
      changes.siScore = newModule.totalSiScore;
      changes.siScoreVendor = newModule.totalSiScoreVendor;
    }
    setEditableProject((currentData) => ({ ...currentData, ...changes }));
    setModules(_modules);
  };

  const onModuleModalClose = () => {
    setModuleModal({
      isOpen: false,
      module: null,
      defaultFields: {},
    });
    setReferenceModule(null);
  };

  const onSaveModule = async (module) => {
    if (module.id) {
      return;
    }

    createModule(module, standardizationProject.id, { onSuccess: addNewModuleLocally });
  };

  const onAddModule = async (moduleData) => {
    try {
      const scoringTable = (
        await getScoringTableStructure(
          standardizationProject.id,
          moduleData.familyId,
          Boolean(moduleData.secondarySystem)
        )
      ).data;
      const newModule = {
        ...moduleData,
        scoringTable: {
          ...scoringTable,
          intent: moduleData.intent,
        },
      };
      await onSaveModule(newModule);

      onModuleModalClose();
    } catch (err) {
      toast.error(err?.message || 'An error occurred. Try again later.');
    }
  };

  const onAddModuleClick = (idCard) => {
    setModuleModal((currentValues) => ({
      ...currentValues,
      isOpen: true,
    }));

    setReferenceModule({
      id: idCard.id,
      project: idCard.project,
      name: idCard.name,
      imageId: idCard.imageId,
      tagId: idCard.tagId,
      tsCode: idCard.tsCode,
    });
  };

  useEffect(() => {
    if (moduleModal.isOpen) {
      setIsSideMenuCollapsed(true);
    }
  }, [moduleModal.isOpen]);

  return {
    moduleModal,
    setModuleModal,
    referenceModule,
    addNewModuleLocally,
    setReferenceModule,
    onModuleModalClose,
    editableProject,
    setEditableProject,
    onAddModule,
    onSaveModule,
    onAddModuleClick,
  };
}
